import { useState, useEffect } from 'react';

const POPUP_1_KEY = 'popup1_closed_date';
const POPUP_2_KEY = 'popup2_closed_date';

function isTodayClosed(key: string): boolean {
  const closed = localStorage.getItem(key);
  if (!closed) return false;
  return closed === new Date().toDateString();
}

const POPUPS = [
  {
    key: POPUP_1_KEY,
    src: 'https://storage.readdy-site.link/project_files/c207dbb9-8e25-402c-98cd-353ca372c5a7/a83d8344-cb2f-468a-a0c1-0cf40bdadbe3_unnamed.jpg?v=df90c62197588dbc1a26005d55ffd7d2',
    alt: '팝업 공지 1',
  },
  {
    key: POPUP_2_KEY,
    src: 'https://storage.readdy-site.link/project_files/c207dbb9-8e25-402c-98cd-353ca372c5a7/23ce9f8b-c6bf-4e82-865f-b2ec135ed0aa_unnamed.jpg?v=a657639b9af9c1076799599464571219',
    alt: '팝업 공지 2',
  },
];

export default function HomePopups() {
  const [openList, setOpenList] = useState<boolean[]>([false, false]);

  useEffect(() => {
    setOpenList(POPUPS.map((p) => !isTodayClosed(p.key)));
  }, []);

  const closePopup = (idx: number, today?: boolean) => {
    if (today) localStorage.setItem(POPUPS[idx].key, new Date().toDateString());
    setOpenList((prev) => prev.map((v, i) => (i === idx ? false : v)));
  };

  const closeAll = () => setOpenList([false, false]);

  const visiblePopups = POPUPS.map((p, i) => ({ ...p, open: openList[i], idx: i })).filter((p) => p.open);

  if (visiblePopups.length === 0) return null;

  // 모바일: 현재 보여줄 팝업 인덱스 (열린 것 중 첫 번째)
  const mobilePopup = visiblePopups[0];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* 딤 배경 */}
      <div className="absolute inset-0 bg-black/50" onClick={closeAll} />

      {/* 데스크탑: 가로 배치 */}
      <div className="relative z-10 hidden md:flex flex-row items-center justify-center gap-4 px-4">
        {visiblePopups.map((popup) => (
          <div key={popup.idx} className="relative bg-white rounded-xl overflow-hidden w-[380px] flex-shrink-0">
            <img
              src={popup.src}
              alt={popup.alt}
              className="w-full object-cover object-top"
            />
            <div className="flex items-center justify-between bg-[#1B3A6B] px-4 py-2.5">
              <button
                onClick={() => closePopup(popup.idx, true)}
                className="text-white/70 text-xs hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                오늘 하루 보지 않기
              </button>
              <button
                onClick={() => closePopup(popup.idx)}
                className="text-white text-xs font-medium hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap"
              >
                닫기 ✕
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* 모바일: 한 번에 하나씩 */}
      <div className="relative z-10 flex md:hidden items-center justify-center px-4 w-full">
        <div className="relative bg-white rounded-xl overflow-hidden w-full max-w-[340px]">
          {/* 팝업 카운터 (2개일 때만) */}
          {visiblePopups.length > 1 && (
            <div className="absolute top-2 right-2 z-10 bg-black/50 text-white text-xs px-2 py-0.5 rounded-full">
              {visiblePopups.indexOf(mobilePopup) + 1} / {visiblePopups.length}
            </div>
          )}
          <img
            src={mobilePopup.src}
            alt={mobilePopup.alt}
            className="w-full object-cover object-top max-h-[70vh]"
          />
          <div className="flex items-center justify-between bg-[#1B3A6B] px-4 py-2.5">
            <button
              onClick={() => closePopup(mobilePopup.idx, true)}
              className="text-white/70 text-xs hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              오늘 하루 보지 않기
            </button>
            <button
              onClick={() => closePopup(mobilePopup.idx)}
              className="text-white text-xs font-medium hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap"
            >
              {visiblePopups.length > 1 ? '다음 ›' : '닫기 ✕'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
